export default {
  mutateAddedSet(state, data) {
    state.addedSet = data;
  },
};
